import { exists } from '@/api'
/**
 *
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 {
  /**
   *
   * @type {string}
   * @memberof InlineResponse200
   */
  message: string
}

export function InlineResponse200FromJSON(json: any): InlineResponse200 {
  return InlineResponse200FromJSONTyped(json)
}

export function InlineResponse200FromJSONTyped(json: any): InlineResponse200 {
  if (json === undefined || json === null) {
    return json
  }
  return {
    message: exists(json, 'message') ? json.message : ''
  }
}

export function InlineResponse200ToJSON(value: InlineResponse200): any {
  return {
    message: value.message
  }
}
